






















































import {
  BButton, BModal, BForm, BFormInput, BFormGroup, BSpinner, BFormSelect, BAlert
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Fonction } from '@/api/models/authorization/fonctions/fonction';
import { CreateProfil } from '@/api/models/authorization/profils/profil';
import { required } from '@validations'
import { PaginatedList } from '@/api/models/common/paginatedList';

@Component({
  components: {
    BAlert,
    BButton, 
    BModal, 
    BForm, 
    BFormInput,
    BFormGroup,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    BFormSelect
  },
})

export default class AddUserFonctionModal extends Vue {
  @Prop({ required: true }) loading!: boolean

  fonctionOptions!: any[]

  required = required;

  fonctionId: string | null = null;

  created() {
    this.loadFonctions()
  }

  async loadFonctions() {
    await this.$http.myressif.fonctions
      .paginatedList(1, 30)
      .then((response: PaginatedList<Fonction>) => {
        this.fonctionOptions = response.items;
        console.log(response);
      });
  }

  async addUserFonction(event: any) {
    event.preventDefault();
    (this.$refs.formValidation as InstanceType<typeof ValidationObserver>)
      .validate()
      .then((isSuccess: any) => {
        if (isSuccess) {
          this.$emit('add-user-fonction', this.fonctionId);
        }
      })
  }
}
